export const appendSlashAtEnd = (value: string): string => `${value}/`
